<template>
    <div class="square-color" :style="{
        '--square-color': color,
        '--size': size + 'px',
    }">
    </div>

</template>

<script>
export default {
    name: 'squareColorUI',
    props: {
        color: {
            type: String,
            required: true
        },
        size: {
            type: Number,
            default: 14
        }
    }
}
</script>

<style scoped>
@import '../../features/report/styles/shared/reportLine/label/square-color.css';
</style>